import { ImplementCycleDetails } from "../../../add-observation-point/add-observation-point-modal";

export class DashboardPageConstants {
    // Title
    public PAGE_TITLE: string = '';

    // Sub-title
    public PAGE_SUBTITLE: string = '';
}

export class EquipmentDetails {
    public SerialNumber: string;
    public UnitNumber: string;
    public Model: string;
    public JobSite: string;
    public SMU: number;
    public LastInspection: string;
}

export class DashboardSearchFilter {
    public Customers: number[];
    public Jobsites: number[];
    public Equipment: number[];
    public Families: number[];
    public Makes: number[];
    public Models: number[];
    public Implements: number[];
    public NoImplemets:boolean;
}

export class DashboardImplementCondition {
    public ImplementName: string;
    public EvalCode: string;
    public WornPct: number;
    public Cracks: number;
    public TotalOP: number;
}

export class DashboardFavouriteImplementsCondition {
    public ImplementCondition: DashboardImplementCondition[][][];
    public CracksPresent: boolean;
}

export class EquipmentImplementDetailsRow {
    public EquipmentRow: string[];
    public EquipmentId: number;
}

export class EquipmentImplementDetails {
    public Details: EquipmentImplementDetailsRow[];
}

export class DashboardFavourites {
    public Id: number;
    public Name: string;
    public DefaultView: number;
}


export class ImplementOverviewModel {

    public condition: number

    public customer: string;
    public jobsite: string;
    public make: string;

    public type: string;


    public status: string;

    public equipment_serialno: string;
    public equipment_unitno: string;

    public repairer: string;

    public workshop: string;

    public equipmentId: number;
    public jobsiteId: number;
    public customerId: number;
    public makeId: number;
    public modelId: number;
    public familyId: number;
    public serialNo: string;
    public unitNo: string;
    public modelDesc: string;
    public siteName: string;
    public currentSMU: number;
    public implementId: number;
    public totalRepairCost:number;
    public BCMTototal:number;
    public TonsTotal: number;
    public Life:number;
    public Residual:number;
}

export class ImplementLocationHistory{
    public Details: ImplementOverviewModel;
    public CycleDetails:ImplementCycleDetails[];
}